<template>
  <crm-side-panel @handleClose="handleCloseDetail">
    <div class="side-panel-content team-member-content">
      <div class="side-panel-buttons">
        <crm-button
          v-if="auth.teamAddUser && auth.teamAddUser.toggleStatus"
          :buttonType="'secondary'"
          :size="'mini'"
          :text="'新增'"
          @click="isAddDialogVisible = true"
        >
        </crm-button>
      </div>
      <div class="header">
        <p class="header-title">团队成员</p>
      </div>
      <!-- 搜索条 -->
      <div class="search-bar">
        <el-col :span="8">
          <el-input
            placeholder="根据名称查询"
            v-model="searchName"
            class="input-with-select"
          >
            <el-select v-model="searchNameType" slot="prepend">
              <el-option label="用户名称" :value="1"></el-option>
              <el-option label="成员账号" :value="2"></el-option>
            </el-select>
            <i
              slot="suffix"
              class="el-input__icon el-icon-search"
              @click="handleSearch"
              style="cursor: pointer"
            ></i>
          </el-input>
        </el-col>
      </div>
      <!-- 团队成员列表 -->
      <el-table
        :data="teamMembers.results"
        v-loading="loading"
        height="100%"
        style="width: 100%"
      >
        <el-table-column prop="loginId" align="center" label="账号">
        </el-table-column>
        <el-table-column prop="guserUserName" align="center" label="用户">
        </el-table-column>
        <el-table-column prop="teamLabel" align="center" label="标签">
          <template slot-scope="scope">
            <span class="tag">{{
              scope.row.teamLabel | memberLabelFilter
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="roleName" align="center" label="角色">
        </el-table-column>
        <el-table-column prop="teamName" align="center" label="团队">
        </el-table-column>
        <el-table-column
          v-if="auth.teamDeleteUser && auth.teamDeleteUser.toggleStatus"
          min-width="100"
          align="center"
          label="操作"
        >
          <template slot-scope="scope">
            <el-button
              v-if="auth.teamTransferUser && auth.teamTransferUser.toggleStatus"
              @click="handleChangeTeam(scope)"
              type="text"
              size="small"
              >更换团队
            </el-button>
            <el-button
              v-if="
                auth.teamUpdateLabelUser &&
                  auth.teamUpdateLabelUser.toggleStatus
              "
              @click="handleChangeLabel(scope)"
              type="text"
              size="small"
              >修改标签</el-button
            >
            <el-button
              v-if="auth.teamDeleteUser && auth.teamDeleteUser.toggleStatus"
              @click="handleDelete(scope)"
              type="text"
              size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 列表分页 -->
      <div class="pageination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
          :current-page="teamMembers.pageNumber"
          :page-sizes="[10, 20, 50]"
          :page-size="teamMembers.pageSize"
          layout="total, sizes, prev, pager, next"
          :total="teamMembers.totalCount"
        >
        </el-pagination>
      </div>

      <!-- 添加成员弹窗 -->
      <el-dialog
        title="添加成员"
        :visible.sync="isAddDialogVisible"
        :width="'500px'"
        append-to-body
        @close="cancelAddDialogVisible"
      >
        <div class="dialog-body addmember-body">
          <el-form
            ref="addMemberForm"
            :rules="userListRules"
            :model="addMemberForm"
          >
            <el-form-item label="成员账号" label-width="100px" prop="loginId">
              <!-- <el-input v-model="addMemberForm.loginId"></el-input> -->
              <el-select
                v-model="addMemberForm.loginId"
                multiple
                filterable
                remote
                collapse-tags
                placeholder="请输入登录账号或姓名"
                :remote-method="getUserList"
                :loading="userLoading"
              >
                <el-option
                  v-for="item in userListOption"
                  :key="item.userId"
                  :label="`${item.loginId + ' ' + item.userName}`"
                  :value="item.loginId"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="标签：" label-width="100px" prop="teamLabel">
              <el-select v-model="addMemberForm.teamLabel">
                <we-search-input-type-options />
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <crm-button
            :buttonType="'plain'"
            :text="'取消'"
            @click="cancelAddDialogVisible"
          >
          </crm-button>
          <crm-button :text="'确定'" @click="handleAddMember"></crm-button>
        </div>
      </el-dialog>

      <!-- 更改团队弹窗 -->
      <el-dialog
        title="转移团队"
        :visible.sync="teamChangeVisible"
        :width="'500px'"
        append-to-body
        @close="teamChangeVisible = false"
      >
        <div class="dialog-body addmember-body">
          <el-form
            label-width="100px"
            class="clearfix"
            ref="teamChangeForm"
            :model="teamChangeForm"
          >
            <p style="margin-left: 40px; margin-bottom: 20px;">
              当前团队: {{ teamChangeForm.teamName }}
            </p>
            <el-form-item
              label="转移后团队:"
              label-width="100px"
              prop="newTeamId"
              :rules="{
                required: true,
                message: '请选择团队',
                trigger: 'blur',
              }"
            >
              <el-cascader
                ref="refHandle"
                :options="teamChangeList"
                placeholder="团队"
                clearable
                :show-all-levels="false"
                :props="{ checkStrictly: true }"
                @change="changeParentTeam"
              />
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <crm-button
            :buttonType="'plain'"
            :text="'取消'"
            @click="teamChangeVisible = false"
          >
          </crm-button>
          <crm-button
            :text="'确定'"
            @click="handleTeamChangeSubmit"
          ></crm-button>
        </div>
      </el-dialog>

      <!-- 修改成员标签弹窗 -->
      <el-dialog
        title="修改标签"
        :visible.sync="labelChangeVisible"
        :width="'500px'"
        append-to-body
        @close="labelChangeVisible = false"
      >
        <div class="dialog-body addmember-body">
          <el-form
            label-width="100px"
            class="clearfix"
            ref="labelChangeForm"
            :model="labelChangeForm"
          >
            <p style="margin-left: 40px; margin-bottom: 20px;">
              {{ labelChangeForm.userName }}（{{ labelChangeForm.loginId }}）
            </p>
            <el-form-item
              label="标签："
              label-width="100px"
              prop="teamLabel"
              :rules="{
                required: true,
                message: '请选择标签',
                trigger: 'change',
              }"
            >
              <el-select v-model="labelChangeForm.teamLabel">
                <we-search-input-type-options />
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <crm-button
            :buttonType="'plain'"
            :text="'取消'"
            @click="labelChangeVisible = false"
          >
          </crm-button>
          <crm-button
            :text="'确定'"
            @click="handleLabelChangeSubmit"
          ></crm-button>
        </div>
      </el-dialog>
    </div>
  </crm-side-panel>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import WeSearchInputTypeOptions from '~component/business/backstage/search-input-type-options';
import CrmSidePanel from '~component/base/crmSidePanel.vue';
import CrmButton from '@/components/base/crmButton';
import CrmCascader from '@/components/base/crmCascader';
import service from '~api/backstage';
import _ from 'lodash';

export default {
  components: {
    WeSearchInputTypeOptions,
    CrmSidePanel,
    CrmButton,
    CrmCascader,
  },
  props: {
    teamMemberKey: {
      type: Object,
    },
  },
  data() {
    var validatorUser = (rule, value, callback) => {
      // if (this.flag === 0) return;
      if (value.length === 0) {
        callback(new Error('请输入登录账号或姓名以选择用户'));
      } else {
        callback();
      }
    };
    return {
      searchNameType: 1,
      searchName: '',
      loading: false,
      userAccount: '',
      userName: '',
      isAddDialogVisible: false,
      teamId: '',
      addMemberForm: {
        loginId: [],
        teamId: '',
        teamType: '',
        teamLabel: null,
      },
      page: {
        pageSize: 10,
        pageNumber: 1,
      },
      // 修改标签弹窗
      labelChangeVisible: false,
      labelChangeForm: {
        teamLabel: null,
        userName: null,
        loginId: null,
      },
      // 修改团队弹窗
      teamChangeVisible: false,
      teamChangeForm: {
        loginId: '',
        teamId: '',
        newTeamId: '',
        teamName: '',
      },
      userListRules: {
        loginId: [
          {
            required: true,
            validator: validatorUser,
            trigger: 'blur',
          },
          {
            required: true,
            message: '请输入登录账号或姓名以选择用户222',
            trigger: 'change',
          },
        ],
        teamLabel: [
          {
            required: true,
            message: '请选择标签',
            trigger: 'change',
          },
        ],
      },
      userLoading: false,
      userListOption: [],
      flag: 0,
    };
  },
  computed: {
    ...mapGetters({
      teamMembers: 'backstage/teamMembers',
      auth: 'authority/auth',
      teamChangeList: 'backstage/teamChangeList',
    }),
  },
  created() {
    // this.getTeamMembers({
    //   pageSize: this.page.pageSize,
    //   pageNumber: this.page.pageNumber,
    //   teamId: this.teamMemberKey.id,
    // });
    this.handleQueryDetail();
    this.addMemberForm.teamId = this.teamMemberKey.id;
    this.addMemberForm.teamType = this.teamMemberKey.teamType;
  },
  methods: {
    ...mapActions({
      getTeamMembers: 'backstage/getTeamMembers',
      deleteTeamMember: 'backstage/deleteTeamMember',
      addTeamMember: 'backstage/addTeamMember',
      memberLabelChange: 'backstage/memberLabelChange',
      handleTeamChange: 'backstage/handleTeamChange',
    }),
    // eslint-disable-next-line
    getUserList: _.debounce(function(query) {
      if (!query) return;
      this.userLoading = true;
      service
        .apiQueryTeamUser({ searchKeyWord: query })
        .then((res) => {
          this.flag = this.flag + 1;
          this.userListOption = res.data.data || [];
        })
        .finally(() => {
          this.userLoading = false;
        });
    }, 400),
    handleQueryDetail() {
      this.loading = true;
      this.getTeamMembers({
        pageSize: this.page.pageSize,
        pageNumber: this.page.pageNumber,
        teamId: this.teamMemberKey.id,
        loginId: this.userAccount,
        guserUserName: this.userName,
      }).finally(() => {
        this.loading = false;
      });
    },
    handleCloseDetail() {
      this.$emit('handleCloseDetail');
    },
    handleStopHideDialog(events) {
      events.stopPropagation();
    },
    handleSearch() {
      this.userName = null;
      this.userAccount = null;
      switch (this.searchNameType) {
        case 1:
          this.userName = this.searchName;
          break;
        case 2:
          this.userAccount = this.searchName;
          break;
        default:
          break;
      }
      this.handleQueryDetail();
      // this.getTeamMembers({
      //   pageSize: this.page.pageSize,
      //   teamId: this.teamMemberKey.id,
      //   loginId: this.userAccount,
      //   guserUserName: this.userName,
      // });
    },
    handleAddMember() {
      this.$refs.addMemberForm.validate((valid) => {
        if (valid) {
          this.addTeamMember(this.addMemberForm).then(() => {
            this.$message({
              type: 'success',
              message: '添加成功',
            });
            this.handleQueryDetail();
            // this.getTeamMembers({
            //   pageSize: this.page.pageSize,
            //   teamId: this.teamMemberKey.id,
            //   loginId: this.userAccount,
            //   guserUserName: this.userName,
            // });
            this.isAddDialogVisible = false;
            this.addMemberForm.loginId = [];
            this.cancelAddDialogVisible();
          });
        }
      });
    },
    handleDelete(scope) {
      this.$confirm(`确定删除${scope.row.guserUserName}`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.deleteTeamMember({
          teamCode: scope.row.teamCode,
          uid: scope.row.uid,
        }).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功',
          });
          this.handleQueryDetail();
          // this.getTeamMembers({
          //   pageSize: this.page.pageSize,
          //   teamId: this.teamMemberKey.id,
          //   loginId: this.userAccount,
          //   guserUserName: this.userName,
          // });
        });
      });
    },
    handleChangeTeam(scope) {
      this.teamChangeVisible = true;
      this.handleTeamChange();
      this.teamChangeForm = {
        teamName: scope.row.teamName,
        loginId: scope.row.loginId,
        teamId: scope.row.teamId,
      };
    },
    handleChangeLabel(scope) {
      this.labelChangeVisible = true;
      this.labelChangeForm = {
        userName: scope.row.guserUserName,
        loginId: scope.row.loginId,
        teamLabel: null,
      };
      if (scope.row.teamLabel) {
        this.labelChangeForm.teamLabel = scope.row.teamLabel;
      }
    },
    handleLabelChangeSubmit() {
      this.$refs.labelChangeForm.validate((valid) => {
        if (valid) {
          this.memberLabelChange(this.labelChangeForm).then(() => {
            this.$message({
              type: 'success',
              message: '标签修改成功',
            });
            this.labelChangeVisible = false;
            this.handleSearch();
          });
        }
      });
    },
    cancelAddDialogVisible() {
      this.isAddDialogVisible = false;
      this.addMemberForm.loginId = [];
      this.addMemberForm.teamLabel = null;
      this.flag = 0;
      this.userLoading = false;
      this.userListOption = [];
      this.$refs.addMemberForm.resetFields();
    },
    handleSizeChange(size) {
      this.page.pageSize = size;
      this.page.pageNumber = 1;
      this.handleQueryDetail();
      // this.getTeamMembers({
      //   pageSize: this.page.pageSize,
      //   pageNumber: this.page.pageNumber,
      //   teamId: this.teamMemberKey.id,
      //   loginId: this.userAccount,
      //   guserUserName: this.userName,
      // });
    },
    handlePageChange(index) {
      this.page.pageNumber = index;
      this.handleQueryDetail();
      // this.getTeamMembers({
      //   pageSize: this.page.pageSize,
      //   pageNumber: this.page.pageNumber,
      //   teamId: this.teamMemberKey.id,
      //   loginId: this.userAccount,
      //   guserUserName: this.userName,
      // });
    },
    changeParentTeam(team) {
      this.teamChangeForm.newTeamId = team[team.length - 1];
      this.$refs.refHandle.dropDownVisible = false;
    },
    async handleTeamChangeSubmit() {
      const params = {
        loginId: this.teamChangeForm.loginId,
        teamId: this.teamChangeForm.teamId,
        newTeamId: this.teamChangeForm.newTeamId,
      };

      service.apiSaveTeamChange(params).then((res) => {
        this.$message('操作成功');
        this.teamChangeVisible = false;
        this.handleQueryDetail();
      });
    },
  },
  filters: {
    memberLabelFilter(val) {
      let result = '';
      switch (val) {
        case 0:
          result = '';
          break;
        case 1:
          result = '销售人员';
          break;
        case 2:
          result = '非销售人员';
          break;
        default:
          break;
      }
      return result;
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@/styles/const.less';
.addmember-body {
  /deep/ .el-select {
    width: 300px !important;
  }
}
.team-member-content {
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
  padding: 0 20px;
  .header {
    .header-title {
      margin: 0 -20px 30px;
      padding-left: 30px;
      background-color: @bg--primary;
      height: 40px;
      line-height: 40px;
      color: #fff;
    }
  }
  .search-bar {
    padding-left: 10px;
    margin-bottom: 20px;
  }
}
</style>
